module.exports = "yeti-modal-footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: right;\n      justify-content: right; }\n\n.yeti-button-positive {\n  min-width: 70px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/approved-lock/approved-lock.component.scss
// module id = 630
// module chunks = 0